export default {
  className: 'bannerImage',
  fields: [
    {
      name: 'link',
      note: '链接商品'
    },
    {
      name: 'image',
      tooltip: '建议690px * 290px',
      validators: [
        (val) => val ? null : '图片不可为空'
      ]
    },
    {
      name: 'backgroundImage',
      tooltip: '建议750px * 368px',
      validators: [
        (val) => val ? null : '背景图不可为空'
      ]
    }
  ],
  search: [
  ]
}
